export const MSG_REQUIRED_FIELD = 'Required field.';
export const MSG_INVALID_EMAIL = 'Invalid email type.';
export const ONE_MINUTE_IN_MS = 60000;
export const MSG_ERROR = 'Error.';
export const TYPE_EVENT = 'event';
export const INTERVAL_FOR_RUNTIME = 10000;
export const ROOMID = '111111111111111111111111';
export const INTERVAL_FOR_RUNTIME_2 = 30000;

export const CONTRACT_EDITOR_CONFIG = {
  placeholder: 'Start typing your content here...',
  readonly: false,
  toolbar: true,
  height: 530,
  uploader: {
    insertImageAsBase64URI: true,
  },
  toolbarSticky: true,
  showCharsCounter: true,
  showWordsCounter: true,
  showXPathInStatusbar: true,
  allowResizeY: true,
  buttons: [
    'bold',
    'italic',
    'underline',
    'strikethrough',
    '|',
    'ul',
    'ol',
    'outdent',
    'indent',
    '|',
    'font',
    'fontsize',
    'brush',
    'paragraph',
    '|',
    'image',
    'table',
    'link',
    '|',
    'align',
    'undo',
    'redo',
    '|',
    'hr',
    'fullsize',
    '|',
    'preview',
    'selectall',
    'cut',
    'copy',
    'paste',
  ],
  buttonsXS: [
    'bold',
    'italic',
    'underline',
    '|',
    'ul',
    'ol',
    '|',
    'undo',
    'redo',
    '|',
    'lineHeight',
  ],
  language: 'en',
  tabIndex: 1,
};

export const AUTOMATED_EMAIL_EDITOR_CONFIG = {
  placeholder: 'Start typing your content here...',
  readonly: false,
  toolbar: true,
  height: 500,
  uploader: {
    insertImageAsBase64URI: true,
  },
  toolbarSticky: true,
  showCharsCounter: true,
  showWordsCounter: true,
  showXPathInStatusbar: true,
  allowResizeY: true,
  buttons: [
    'bold',
    'italic',
    'underline',
    'strikethrough',
    '|',
    'ul',
    'ol',
    'outdent',
    'indent',
    '|',
    'font',
    'fontsize',
    'brush',
    'paragraph',
    '|',
    'image',
    'table',
    'link',
    '|',
    'align',
    'undo',
    'redo',
    '|',
    'hr',
    'fullsize',
    '|',
    'preview',
    'selectall',
    'cut',
    'copy',
    'paste',
  ],
  buttonsXS: [
    'bold',
    'italic',
    'underline',
    '|',
    'ul',
    'ol',
    '|',
    'undo',
    'redo',
  ],
  language: 'en',
  tabIndex: 1,
};

export const LINK_VARIABLES = [
  {
    id: 1,
    label: 'For User Name',
    value: '*|user-name|*',
  },
  {
    id: 2,
    label: 'For User Email',
    value: '*|user-email|*',
  },
  {
    id: 3,
    label: 'For Listing Company Name',
    value: '*|listing-company-name|*',
  },
  {
    id: 4,
    label: 'For Listing Headline',
    value: '*|listing-headline|*',
  },
  {
    id: 5,
    label: 'For Broker Name',
    value: '*|broker-name|*',
  },
  {
    id: 6,
    label: 'For Password Reset link',
    value: '*|pwd-reset|*',
  },
  {
    id: 7,
    label: 'For Account Activation link',
    value: '*|activate-account-link|*',
  },
  {
    id: 8,
    label: 'For Broker Email',
    value: '*|broker-email|*',
  },
  {
    id: 9,
    label: 'For Broker Phone',
    value: '*|broker-phone|*',
  },
  {
    id: 10,
    label: 'Project Name',
    value: '*|project-name|*',
  },
  {
    id: 11,
    label: 'Creator',
    value: '*|creator|*',
  },
  {
    id: 12,
    label: 'Create Date',
    value: '*|create-date|*',
  },
  {
    id: 13,
    label: 'Due Date',
    value: '*|due-date|*',
  },
  {
    id: 14,
    label: 'Set up password',
    value: '*|set-up-password|*',
  },
  {
    id: 15,
    label: 'Sign NDA',
    value: '*|sign-NDA|*',
  },
  {
    id: 16,
    label: 'Insert Link',
    value: '*|insert-link|*',
  },
  {
    id: 17,
    label: 'Client Name',
    value: '*|client-name|*',
  },
  {
    id: 18,
    label: 'Login Link',
    value: '*|login-link|*',
  },
  {
    id: 19,
    label: 'Seller Name',
    value: '*|seller-name|*',
  },
  {
    id: 20,
    label: 'Seller Email',
    value: '*|seller-email|*',
  },
  {
    id: 21,
    label: 'Listing Front Link',
    value: '*|listing-front-link|*',
  },
  {
    id: 22,
    label: 'User Name Assigned Project',
    value: '*|user-name-assigned-project|*',
  },
  {
    id: 23,
    label: 'Task assigned to',
    value: '*|task-assigned-to|*',
  },
  {
    id: 24,
    label: 'Task due date',
    value: '*|task-due-date|*',
  },
  {
    id: 25,
    label: 'Task create date',
    value: '*|task-create-date|*',
  },
  {
    id: 26,
    label: 'Task creator',
    value: '*|task-creator|*',
  },
  {
    id: 27,
    label: 'Task assignee',
    value: '*|task-assignee|*',
  },
  {
    id: 28,
    label: 'NDA download link',
    value: '*|nda-download-link|*',
  },
  {
    id: 29,
    label: 'To Do Create Date',
    value: '*|to-do-create-date|*',
  },
  {
    id: 30,
    label: 'To Do Due Date',
    value: '*|to-do-due-date|*',
  },
  {
    id: 31,
    label: 'To Do Assignee',
    value: '*|to-do-assignee|*',
  },
  {
    id: 32,
    label: 'To Do Creator',
    value: '*|to-do-creator|*',
  },
  {
    id: 33,
    label: 'To Do Creator',
    value: '*|to-do-creator|*',
  },
  {
    id: 34,
    label: 'BVI Submitted',
    value: '*|bvi-submitted|*',
  },
  {
    id: 35,
    label: 'Internal User Account Activate Link',
    value: '*|internal-user-acct-activate-link|*',
  },
  {
    id: 36,
    label: 'Internal User Account Status Change',
    value: '*|internal-user-account-status-change|*',
  },
  {
    id: 37,
    label: 'User Account Activated',
    value: '*|user-account-activated|*',
  },
  {
    id: 38,
    label: 'Internal User Email',
    value: '*|internal-user-email|*',
  },
  {
    id: 39,
    label: 'Internal User Name',
    value: '*|internal-user-name|*',
  },
  {
    id: 40,
    label: 'Internal User Password Reset Link',
    value: '*|internal-user-password-reset-link|*',
  },
  {
    id: 41,
    label: 'User requested password reset',
    value: '*|user-password-reset-link|*',
  },
  {
    id: 42,
    label: 'User updated email',
    value: '*|change-email-link|*',
  },
  {
    id: 43,
    label: 'Current User Email',
    value: '*|user-logged-in|*',
  },
  {
    id: 44,
    label: 'Signature',
    value: '*|signature|*',
  },
  {
    id: 45,
    label: 'BVI Sender',
    value: '*|bvi-sender|*',
  },
  {
    id: 46,
    label: 'BVI Sender Name',
    value: '*|bvi-sender-name|*',
  },
  {
    id: 47,
    label: 'Assigned User Of Deal Room',
    value: '*|user-assigned-to-data-room|*',
  },
  {
    id: 48,
    label: 'The Assigned User',
    value: '*|user-to-sign|*',
  },
  {
    id: 49,
    label: 'The name of Contract Agreement',
    value: '*|document-name|*',
  },
  {
    id: 50,
    label: 'The verification code',
    value: '*|verification-code|*',
  },
  {
    id: 51,
    label: 'Download contacts CSV file link',
    value: '*|download-contacts-file-link|*',
  },
  {
    id: 52,
    label: 'For User Phone',
    value: '*|user-phone|*',
  },
  {
    id: 53,
    label: 'For Buyer Phone',
    value: '*|buyer-phone|*',
  },
  {
    id: 54,
    label: 'For Seller Phone',
    value: '*|seller-phone|*',
  },
  {
    id: 55,
    label: 'For All Brokers Phone',
    value: '*|all-brokers-phone|*',
  },
  {
    id: 55,
    label: 'Internal User Phone',
    value: '*|internal-user-phone|*',
  },
  {
    id: 56,
    label: 'To Do Assignee Name',
    value: '*|to-do-assignee-name|*',
  },
  {
    id: 57,
    label: 'To Do Assignee Phone',
    value: '*|to-do-assignee-phone|*',
  },
  {
    id: 58,
    label: 'Task Name',
    value: '*|task-name|*',
  },
];

export const EMAIL_LINK_TRIGGER = [
  { value: 'activeUser', label: 'New User Created' },
  {
    value: 'taskTemplate',
    label: 'Email when task is created (for all participants)',
  },
  {
    value: 'bizbuysellNewUser',
    label: 'Bizbuysell Form Filled [New Customer]',
  },
  {
    value: 'bizbuysellExistingUser',
    label: 'Bizbuysell Form Filled [Existing Customer]',
  },
  { value: 'buyerNdaSignAuto', label: 'Buyer signed NDA [Listing automated]' },
  {
    value: 'buyerNdaSubmitUnauto',
    label: 'Buyer signed NDA [Listing not automated]',
  },
  {
    value: 'projectTemplate',
    label: 'Email to participants when new project is created',
  },
  {
    value: 'brokerNdaSignAuto',
    label: 'Email to Broker when NDA is signed [Listing Automated]',
  },
  {
    value: 'brokerNdaSubmitUnauto',
    label: 'Email to Broker when NDA is signed [Listing NOT Automated]',
  },
  { value: 'BVIassignedMail', label: 'BVI Assigned' },
  { value: 'roomBuyerTemplate', label: 'Deal room assigned to buyer' },
  { value: 'roomSellerTemplate', label: 'Deal room assigned to seller' },
  { value: 'room3rdPartyTemplate', label: '3rd party deal room assigned' },
  { value: 'uploadTemplate', label: 'Files uploaded to deal room' },
  { value: 'ToDoAssigned', label: 'To-do assigned' },
  { value: 'UserActivatedAccount', label: 'User activated' },
  { value: 'ListingStatusChange', label: 'Listing status change' },
  {
    value: 'InternalUserAdded',
    label: 'New internal user added [admin/broker]',
  },
  { value: 'InternalUserActivated', label: 'Internal user activated' },
  {
    value: 'InternalPasswordReset',
    label: 'Internal User requested password reset',
  },
  { value: 'passwordReset', label: 'User requested password reset' },
  { value: 'changeEmail', label: 'User updated email' },
  { value: 'interestAdded', label: 'Interest Added' },
  { value: 'VIPUserAdded', label: 'VIP User Added' },
  { value: 'submitBVI', label: 'Seller Submit BVI' },
  { value: 'ndaApproved', label: 'NDA Approved' },
  { value: 'uploadByBrokerAdmin', label: 'Upload By Broker Admin' },
  { value: 'uploadByUser', label: 'Upload By User' },
  { value: 'sendForSignature', label: 'Send For Signature' },
  { value: 'sendTrigger', label: 'Send For Trigger' },
  { value: 'sendEmailCode', label: 'Send Email Code For Login' },
  { value: 'sendContactsResult', label: 'Send The Contacts CSV File Via Email' },
];

export const SMS_LINK_TRIGGER = [
  {
    value: 'bizbuysellNewUser',
    label: 'Bizbuysell Form Filled [New Customer]',
  },
  {
    value: 'bizbuysellExistingUser',
    label: 'Bizbuysell Form Filled [Existing Customer]',
  },
  { value: 'BVIassignedMail', label: 'BVI Assigned' },
  { value: 'roomBuyerTemplate', label: 'Deal room assigned to buyer' },
  { value: 'passwordReset', label: 'User requested password reset' },
  { value: 'roomSellerTemplate', label: 'Deal room assigned to seller' },
  {
    value: 'projectTemplate',
    label: 'SMS to participants when new project is created',
  },
  {
    value: 'buyerNdaSubmitUnauto',
    label: 'Buyer signed NDA [Listing not automated]',
  },
  { value: 'buyerNdaSignAuto', label: 'Buyer signed NDA [Listing automated]' },
  { value: 'roomBuyerTemplate', label: 'Deal room assigned to buyer' },
  { value: 'room3rdPartyTemplate', label: '3rd party deal room assigned' },
  { value: 'uploadTemplate', label: 'Files uploaded to deal room' },
  { value: 'ToDoAssigned', label: 'To-do assigned' },
  {
    value: 'ToDoExpiringIn5Days',
    label: 'To-do expiring in 5 days',
  },
  {
    value: 'ToDoExpiringToday',
    label: 'To-do expiring today',
  },
  {
    value: 'InternalPasswordReset',
    label: 'Internal User requested password reset',
  },
  { value: 'submitBVI', label: 'Seller Submit BVI' },
  { value: 'ndaApproved', label: 'NDA Approved' },
];

export const TRIGGER_STATUS_OPTIONS = [
  { label: 'Inquired', value: 'inquired' },
  { label: 'NDA-Signed/Approved', value: 'nda' },
];
